{{ getStatus | call : task?.status }}
